// extracted by mini-css-extract-plugin
export default {"shopCard":"dmJZYaKK","cartCard":"kIr4jtYj","cartFlexBlock":"fPxLiA4x","cartImgBox":"MdsqEbk6","cardNameDesc":"ItnOZG1u","cardNameMob":"lCxwFyLG","shopImgBox":"xWPXRNMa","noBackground":"NjUilADu","img":"X1fMg4PX","name":"sGjpM5L7","price":"fjFSEIVE","countWrapper":"_jEpjDYG","buyButton":"gufEwrJQ","buyButton2":"unzrOlI7","delete":"SbZ0A0it","countButton":"LeP56FYd","noStroke":"PHY_mfMB","amountCount":"yeKF4sG4","disabled":"_Mi9r9Aw","hidden":"UIGiWDy4","visible":"YOJYvLoS"};
    if(module.hot) {
      // 1738090063425
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  